export default __webpack_public_path__ + "assets/b8f1aa7f064fa9e06c439daf9d55028d.svg";